module.exports = __webpack_public_path__ + "static/media/14.a9b63592.jpg";